import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit, OnChanges {

  @Input('page')page = 1;
  @Input('total')total = 0;
  @Input('perPage')perPage = 30;
  @Input('visablePages')visablePages = 10;
  @Output('changePage')changePage = new EventEmitter();
  @Output('changeOffset')changeOffset = new EventEmitter();
  public totalPages = 0;
  public pages: any[];

  public get diapasonText() {
    return this.translate.instant('Показано: {{from}} — {{to}} из {{total}}', {
      from: this.diapason.from,
      to: this.diapason.to,
      total: this.total
    });
  }

  public get diapason() {
    const pageNum = this.page || 1;
    let from, to;
    from = (pageNum - 1) * this.perPage;
    to = pageNum * this.perPage;
    to = to > this.total ? this.total : to;
    return {
      from,
      to
    };
  }

  constructor(
    private translate: TranslateService
  ) {}

  private getPages() {
    let startVisableDiapason: number = this.page - Math.ceil(this.visablePages / 2);
    startVisableDiapason = startVisableDiapason <= 0 ? 0 : startVisableDiapason;

    if ( (this.totalPages - this.visablePages) <= startVisableDiapason ) {
      startVisableDiapason = (this.totalPages - this.visablePages) > 0 ? (this.totalPages - this.visablePages) : 0
    }

    const visableDiapason: any[] = new Array(this.visablePages > this.totalPages ? this.totalPages : this.visablePages)
      .fill(null).map((x, i) => ++startVisableDiapason);
    return  visableDiapason;
  }

  ngOnInit() {
    this.totalPages = this.total ? Math.ceil(this.total / this.perPage) : 0;
    this.pages = this.getPages();
  }

  ngOnChanges(changes: any) {
    this.total = changes.total.currentValue;
    this.totalPages = this.total ? Math.ceil(this.total / this.perPage) : 0;
    this.pages = this.getPages();
  }

  public change(i) {
    i = i <= 1 ? 1 : i;
    i = i >= this.totalPages ? this.totalPages : i;
    this.page = i;
    this.changePage.emit(this.page);
    this.changeOffset.emit((this.page - 1) * this.perPage);
    this.pages = this.getPages();
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/pagination/pagination.component.ts